import styled from 'styled-components';

const AnimationText = styled.p`
  color: ${(props) => props.theme.colors.text.primary};
  text-align: center;
  font-weight: ${(props) => props.theme.typography.fontWeight.medium};
`;

const DeleteWrapper = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: ${(props) => props.theme.borderRadius.circle};
  transition: ${(props) => props.theme.transitions.fast};

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const DeleteIcon = styled.img`
  width: 1.6rem;
  height: 1.6rem;
`;

const DetailWrapper = styled.div`
  flex: 1;
  margin-left: ${(props) => props.theme.spacing.md};
  overflow: hidden;
`;

const ExtraSpace = styled.div`
  height: ${(props) => props.theme.spacing.xl};
`;

const Text = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ImageSize = styled.p`
  margin: ${(props) => props.theme.spacing.xs} 0 0;
  color: ${(props) => props.theme.colors.text.secondary};
`;

const Wrapper = styled.div`
  margin: 0 auto;
  height: 100%;
  padding: 1.5rem;
`;

const Title = styled.h1`
  margin: 0;
  padding: 0;
  color: ${(props) => props.theme.colors.text.primary};
`;

const ImageCard = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => props.theme.spacing.md};
  border-radius: ${(props) => props.theme.borderRadius.md};
  background-color: ${(props) => props.theme.colors.background.secondary};
  box-shadow: ${(props) => props.theme.shadows.sm};
`;

const PreviewImage = styled.img`
  height: 5rem;
  width: 5rem;
  object-fit: cover;
  border-radius: ${(props) => props.theme.borderRadius.sm};
`;

const SubHeader = styled.p`
  margin: 0.5rem 0 0;
  padding: 0;
  font-size: ${(props) => props.theme.typography.fontSize.sm};
  color: ${(props) => props.theme.colors.text.secondary};
`;

const ImagesContainer = styled.div`
  margin-top: ${(props) => props.theme.spacing.lg};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.md};
`;

const ButtonContainer = styled.div`
  flex: 1;
  padding: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    cursor: pointer;
  }
  flex-direction: column;
  span {
    color: #4a4a4a;
    font-weight: 500;
    font-size: 1.1rem;
    margin-top: 0.5rem;
    cursor: pointer;
  }
`;

const Container = styled.div`
  width: 6.4rem;
  height: 6.4rem;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.brand.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem auto;
  width: 100%;
`;

const UploadImage = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 2.4rem;
    height: 2.4rem;
  }
`;

const UploadIcon = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 2.4rem;
    height: 2.4rem;
  }
`;

const UploadMessage = styled.p`
  text-align: left;
  margin: 0.5rem 0;
`;

const AttentionContainer = styled.div`
  margin: 1.6rem 0;
  background-color: ${(props) => props.theme.colors.background.secondary};
  padding: 1rem;
  border-radius: 0.6rem;
  color: ${(props) => props.theme.colors.text.secondary};

  span {
    color: ${(props) => props.theme.colors.brand.tertiary};
    font-weight: ${(props) => props.theme.typography.fontWeight.bold};
    display: inline-block;
    margin-bottom: ${(props) => props.theme.spacing.xs};
  }
`;

const PasswordInputContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;

const DropZoneContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;

  .dropzone-area {
    border: 2px dashed
      ${(props) => (props.isDragging ? props.theme.colors.brand.primary : '#ddc9f4')};

    border-radius: 0.8rem;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    margin: 1.6rem 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 1.6rem;
    min-height: 200px;

    &:hover {
      border-color: #a6a6a6b5;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
      min-height: 160px;
    }
  }
`;

const DropContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.lg};
  height: fit-content;
  padding-bottom: 1rem;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    flex-direction: row;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    .divider {
      border-top: 1px solid lightgrey;
      margin: 0 -1.5rem;
      margin-top: 1rem;
    }
  }
`;

const EachOption = styled.li`
  text-decoration: none;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.text.secondary};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-size: ${(props) => props.theme.typography.fontSize.sm};
  line-height: 1.5;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.background.secondary};
    color: ${(props) => props.theme.colors.brand.primary};
  }

  /* Style any nested HTML from the parsed content */
  p,
  span {
    margin: 0;
    padding: 0;
  }

  b,
  strong {
    color: ${(props) => props.theme.colors.text.primary};
    font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  }
`;

const PasswordInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.6rem;
  font-size: ${(props) => props.theme.typography.fontSize.sm};
  color: ${(props) => props.theme.colors.text.primary};
  outline: none;
  transition: all 0.2s ease-in-out;

  &::placeholder {
    color: ${(props) => props.theme.colors.text.secondary};
  }

  &:focus {
    border-color: ${(props) => props.theme.colors.brand.primary};
    box-shadow: 0 0 0 2px ${(props) => `${props.theme.colors.brand.primary}1A`};
  }
`;

const FilePreview = styled.div`
  width: 100%;
  padding: 1.5rem;
  flex-grow: 1;
  background: #f8f2ff;
`;

const FileHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 0;
  width: 100%;
`;

const FileIcon = styled.img`
  width: 2.4rem;
  height: 2.4rem;
`;

const FileName = styled.span`
  font-size: ${(props) => props.theme.typography.fontSize.md};
  font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  color: ${(props) => props.theme.colors.text.primary};
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  flex: 1;
  text-align: left;
`;

const FileInfo = styled.div`
  margin-bottom: ${(props) => props.theme.spacing.md};
  text-align: center;
`;

const FileSize = styled.span`
  color: ${(props) => props.theme.colors.text.secondary};
  font-size: ${(props) => props.theme.typography.fontSize.xs};
  margin-top: 0;
`;

const FileActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
`;

const FileButton = styled.button`
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.6rem;
  padding: 0.8rem 1.6rem;
  font-size: ${(props) => props.theme.typography.fontSize.sm};
  font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.8rem;

  &:hover {
    background-color: #f8fafc;
  }
`;

const SupportedFormats = styled.p`
  font-size: ${(props) => props.theme.typography.fontSize.xs};
  color: ${(props) => props.theme.colors.text.secondary};
  margin-top: -1rem;
  text-align: center;
`;

// New styled components for password section to match UploadDocument
const PasswordBox = styled.div`
  margin: 1.6rem 0;
  background-color: ${(props) => props.theme.colors.background.secondary};
  padding: 1rem;
  border-radius: 0.6rem;
`;

const PasswordLabel = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  margin-bottom: 0.5rem;
`;

const LockIcon = styled.img`
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.2rem;
`;

const PasswordText = styled.p`
  margin: 0;
  font-size: ${(props) => props.theme.typography.fontSize.sm};
  color: ${(props) => props.theme.colors.brand.tertiary};
  text-align: justify;
  text-justify: inter-word;
  hyphens: auto;
`;

const TogglePasswordButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 1.2rem;
  background: none;
  border: none;
  cursor: pointer;
`;

const UploadIconContainer = styled.div`
  width: 6.4rem;
  height: 6.4rem;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.brand.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 4.8rem;
    height: 4.8rem;
  }
`;

const TextContainer = styled.div`
  text-align: left;
`;

const UploadDescription = styled.p`
  font-size: ${(props) => props.theme.typography.fontSize.xs};
  color: ${(props) => props.theme.colors.text.secondary};
  margin: 0;
`;

const UploadButton = styled.button`
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.6rem;
  padding: 0.8rem 1.6rem;
  font-size: ${(props) => props.theme.typography.fontSize.sm};
  font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  cursor: pointer;
  margin-bottom: 0.8rem;
  display: inline-block;
  text-align: center;

  &:hover {
    background-color: #f8fafc;
  }
`;

const BodyContainer = styled.div``;

const MainUploadSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  border-radius: 0.6rem;
  padding: 1.5rem;
  width: 100%;
  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 1rem;
  }
`;

const CardContent = styled.div`
  padding: 1.5rem;
`;

const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 2rem 2rem;
`;

const CommonInstructionsContainer = styled.div`
  font-size: ${(props) => props.theme.typography.fontSize.sm};
  margin: 0;
  background-color: ${(props) => props.theme.colors.background.secondary};
  padding: 1rem;
  border-radius: 0.6rem;
`;

export {
  BodyContainer,
  AnimationText,
  AttentionContainer,
  DeleteWrapper,
  DeleteIcon,
  DetailWrapper,
  ExtraSpace,
  Text,
  ImageSize,
  Wrapper,
  Title,
  ImageCard,
  PreviewImage,
  SubHeader,
  ImagesContainer,
  ButtonContainer,
  Container,
  UploadImage,
  UploadIcon,
  UploadMessage,
  DropZoneContainer,
  EachOption,
  PasswordInput,
  DropContainer,
  PasswordInputContainer,
  FilePreview,
  FileHeader,
  FileIcon,
  FileName,
  FileInfo,
  FileSize,
  FileActions,
  FileButton,
  SupportedFormats,
  PasswordBox,
  PasswordLabel,
  LockIcon,
  PasswordText,
  TogglePasswordButton,
  UploadIconContainer,
  TextContainer,
  UploadDescription,
  UploadButton,
  MainUploadSection,
  CardContent,
  CardFooter,
  CommonInstructionsContainer,
};
